import React from 'react';
import './BalanceCard.css';

export interface BalanceCardProps {
  member: {
    id: string;
    name: string;
    email: string;
    avatar?: string;
    balance: number;
  };
  onSettleUp?: (memberId: string) => void;
  onMarkPaid?: (memberId: string) => void;
  showActions?: boolean;
}

const BalanceCard: React.FC<BalanceCardProps> = ({
  member,
  onSettleUp,
  onMarkPaid,
  showActions = false
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const getBalanceColor = (balance: number) => {
    if (balance > 0) return 'positive';
    if (balance < 0) return 'negative';
    return 'neutral';
  };

  const getBalanceLabel = (balance: number) => {
    if (balance > 0) return 'Owed to you';
    if (balance < 0) return 'You owe';
    return 'Settled up';
  };

  return (
    <div className="balance-card">
      <div className="member-info">
        <div className="member-avatar">
          {member.avatar ? (
            <img src={member.avatar} alt={member.name} />
          ) : (
            <span>{member.name.charAt(0)}</span>
          )}
        </div>
        <div className="member-details">
          <h4 className="member-name">{member.name}</h4>
          <p className="member-email">{member.email}</p>
          <p className="balance-label">{getBalanceLabel(member.balance)}</p>
        </div>
      </div>
      
      <div className="balance-section">
        <div className={`balance-amount ${getBalanceColor(member.balance)}`}>
          {formatCurrency(Math.abs(member.balance))}
        </div>
        
        {showActions && member.balance !== 0 && (
          <div className="balance-actions">
            {member.balance > 0 ? (
              <button
                className="action-btn action-btn-success"
                onClick={() => onMarkPaid?.(member.id)}
              >
                Mark Paid
              </button>
            ) : (
              <button
                className="action-btn action-btn-secondary"
                onClick={() => onSettleUp?.(member.id)}
              >
                Settle Up
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BalanceCard; 